module.exports = __webpack_public_path__ + "static/media/LogoFPJ_Black.00e280cd.png";